import { BaseDictionaryItem } from '../../public_api';
import { DictionaryItemStatus } from './dictionaryItemStatus.enum';

export class ObservationTypesDictionaryItem extends BaseDictionaryItem {
  public static readonly STUTUS = 'status';

  public readonly status: DictionaryItemStatus;

  protected constructor(sourceObject: Record<string, unknown>, id: string, name: string, description: string) {
    super(sourceObject, id, name, description);
    this.status = super._getEnum(ObservationTypesDictionaryItem.STUTUS, DictionaryItemStatus);
  }
}
